import { createSlice } from "@reduxjs/toolkit";
import { IFreshmanProcessSlice } from "../../../models/freshman/freshmanProcess";


const initialMainStepState: IFreshmanProcessSlice = {
    mainStepProcess: undefined,
    subStepProcess: undefined,
    freshmanProcessVersion: undefined
};

const freshmanProcessSlice = createSlice({
    name: "mainStep",
    initialState: initialMainStepState,
    reducers: {
        setMainStepProcess: (state, action: { payload: any }) => {
            state.mainStepProcess = action.payload;
        },
        setSubStepProcess: (state, action: { payload: any }) => {
            state.subStepProcess = action.payload;
        },
        setFreshmanProcessVersion: (state, action: { payload: any }) => {
            state.freshmanProcessVersion = action.payload;
        },

    },
});

export const { setMainStepProcess, setSubStepProcess, setFreshmanProcessVersion } = freshmanProcessSlice.actions;

const freshmanProcessReducer = freshmanProcessSlice.reducer;

export type freshmanProcessState = ReturnType<typeof freshmanProcessReducer>;

export default freshmanProcessReducer;
